export const companyInfo={name:'ABT Smart Audio',description:'Nền tảng phát thanh thông minh'};
